// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: window["env"]["production"],
    isDebugMode: window["env"]["debugMode"],
    jsonuri: 'assets/',
    apiEndPoint: window["env"]["apiEndPoint"],
    apiEndPointAnagrafeWS: window["env"]["anagrafeWS"],
    apiEndPointGrowApp: window["env"]["apiEndPointGrowApp"],

    loginEndPoint: window["env"]["loginEndPoint"],

    //Chiamata per filtro featureInfo
    endpointGetHtml: window["env"]["getHtml"],

    //Chiamata per configurazione metadata
    endpointMetadata: window["env"]["geoPluginMetadata"],

    //Chiamata per configurazione layers
    endpointLayers: window["env"]["geoPluginLayers"],
    endPointGeoserver: window["env"]["geoserver"],

    cisia: 'https://www.regione.lazio.it/',

    menuEndPoint: window["env"]["menu"],

    psrEndPoint: '../growpsr/#/anagrafica',

    // WSO2
    discoveryDocumentEndpoint: window["env"]["discoveryDocumentEndpoint"],
    redirectUri: window["env"]["redirectUri"],
    logoutUrl: window["env"]["logoutUrl"],
    clientId: window["env"]["clientId"],
    dummyClientSecret: window["env"]["dummyClientSecret"],
    scope: 'openid',
    responseType: 'code',
    sessionChecksEnabled: false,
    // begin: richiesto perche' il documento non e' completamente conforme
    strictDiscoveryDocumentValidation: false,
    skipIssuerCheck: true,
    // end: richiesto perche' il documento non e' completamente conforme
    requireHttps: false,
    showDebugInformation: true,
    disablePKCE: false,
    useHttpBasicAuth: true,
    customQueryParams: { acr_values: "https://www.spid.gov.it/SpidL2" },

    TIMEOUT_SPINNER: 120000,
};

